//#region components/root_layout/root_layout_constants.js
var e = {
	START: "start",
	END: "end",
	LEFT: "left",
	RIGHT: "right"
}, t = [
	"sm",
	"md",
	"lg",
	null
], n = {
	ROOT_LAYOUT_SIDEBAR_POSITIONS: e,
	ROOT_LAYOUT_RESPONSIVE_BREAKPOINTS: t
};
//#endregion
export { t as ROOT_LAYOUT_RESPONSIVE_BREAKPOINTS, e as ROOT_LAYOUT_SIDEBAR_POSITIONS, n as default };

//# sourceMappingURL=root-layout-constants.js.map